type EventType = { name: string; event: Event };
type EventsType = { [key: string]: EventType };

const events: EventsType = {
  UNLOCK: { name: 'UNLOCK', event: new Event('UNLOCK') },
};

export default events;
